import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MMatching from '@/modules/MMatching.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingView',
  props: {
    tId: {},
    zoneId: {}
  },
  setup(__props: any) {



document.getElementById('app').scrollIntoView({ behavior: 'smooth' })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MMatching, {
    "t-id": _ctx.tId,
    "zone-id": _ctx.zoneId,
    "data-qe-id": "matching"
  }, null, 8, ["t-id", "zone-id"]))
}
}

})